import ErrorCandy from './ErrorCandy'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './Errors.css'

interface Props {
  css?: any
}

interface State {}

@observer
export default class Errors extends Component<Props, State> {
  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return <div {...classes('container')}>
      {this.store.errors.list.length > 0 && this.renderList()}
    </div>
  }

  renderList() {
    const {props} = this
    const classes = resolveCss(css, props.css)

    return <div {...classes('errors')}>
      {this.store.errors.list.map((errorId) => {
        const error = this.store.errors.byId.get(errorId)
        return <ErrorCandy key={`error-${errorId}`} error={error} />
      })}
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/Errors/Errors.tsx